module.exports = __webpack_public_path__ + "img/banners-mobile.0f0c0bd7.jpg";